import { render, staticRenderFns } from "./InvitationDetail.vue?vue&type=template&id=20fd9644"
import script from "./InvitationDetail.vue?vue&type=script&lang=js"
export * from "./InvitationDetail.vue?vue&type=script&lang=js"
import style0 from "./InvitationDetail.vue?vue&type=style&index=0&id=20fd9644&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports